
export const getAccessToken = () => {
    const token = localStorage.getItem('access-token');
    return token
}

export const setAccessToken = (token: string) => {
    localStorage.setItem('access-token', token);
}

export const removeAccessToken = () => {
    localStorage.removeItem('access-token');
}